import CommentsCountComponent from "../components/comments-count-component";
import {RenderPosition, render} from "../utils/render";

export default class CommentsCountController {
  constructor({className = ``, count = 0, isShowEnding = true, onClickHandler}) {
    this._className = className;
    this._count = count;
    this._isShowEnding = isShowEnding;
    this._onClickHandler = onClickHandler;
  }

  render(container) {
    const button = new CommentsCountComponent({
      className: this._className,
      title: this._count,
      isShowEnding: this._isShowEnding,
    });

    button.setClickHanlder(this._onClickHandler);

    render(container, button.getElement(), RenderPosition.BEFOREEND);
  }
}
